import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage } from 'react-intl';

import { addToCartFromPixAndMix, removeFromCart } from 'Redux/ducks/cart';

const SelectButton = ({ id, slug, selected, soldOut, desktopButton }) => {
  const dispatch = useDispatch();
  const handleAdd = () => {
    dispatch(addToCartFromPixAndMix(id, slug));
  };

  const handleRemove = () => {
    dispatch(removeFromCart(id));
  };

  return (
    <div className="select-button">
      <button
        disabled={soldOut}
        className={`select-btn btn-primary ${selected ? 'btn-selected' : ''}`}
        selected={selected}
        onClick={selected ? handleRemove : handleAdd}
      >
        {!desktopButton &&
          <React.Fragment>
            {selected ? <FontAwesomeIcon icon={faTrashCan} className="mr-1" /> : <FontAwesomeIcon icon={faPlus} className="mr-1" />}
            {selected ? <FormattedMessage id="pickandmix.select.remove" defaultMessage="Remove" /> : <FormattedMessage id="pickandmix.select.add" defaultMessage="Add" />}
          </React.Fragment>
        }
        {desktopButton &&
          <React.Fragment>
            {selected ?
              <>
                <FontAwesomeIcon icon={faTrashCan} className="mr-1" />
                <FormattedMessage id="pickandmix.select.removefrombundle" defaultMessage="Remove from bundle" />
              </>

              :

              <>
                <FontAwesomeIcon icon={faPlus} className="mr-1" />
                <FormattedMessage id="pickandmix.select.addtobundle" defaultMessage="Add to bundle" />
              </>
            }
          </React.Fragment>
        }
      </button>
    </div>
  );
};

SelectButton.propTypes = {
  id: PropTypes.string,
  slug: PropTypes.string,
  selected: PropTypes.bool,
  soldOut: PropTypes.bool,
  desktopButton: PropTypes.bool,
};

SelectButton.defaultProps = {
  id: '',
  slug: '',
  selected: false,
  soldOut: false,
  desktopButton: false,
};

export default SelectButton;
